import React, { FC, SyntheticEvent, useContext } from 'react'
import { Trans, t } from '@lingui/macro'

import { Dropdown } from '../../../components/common/dropdown/Dropdown'
import IconPeople from '../../../components/common/icon/IconPeople'
import FilterCampaignActionsModal, {
  getFlatListOfActions,
  ICampaignActionForModal
} from './FilterCampaignActionsModal'
import { ICampaignLinkReportsFilters } from './CampaignLinkReport'
import { ManageCampaignContext } from '../ManageCampaignPage'

import '../campaign-action-reports/CampaignActionReportFilters.less'
import { ButtonClean, ButtonDark, Flex } from 'front-end/src/components'
import IconClose from 'front-end/src/components/common/icon/IconClose'
import IconPlus2 from 'front-end/src/components/common/icon/IconPlus2'
import { IconFilter } from 'front-end/src/components/common/icon/IconFilter'

interface IProps {
  onFilterChange: (filters: Partial<ICampaignLinkReportsFilters>) => void
  filters: ICampaignLinkReportsFilters
  showActionsFilterModal: boolean
  setShowActionsFilterModal: (show: boolean) => void
}

const CampaignLinkReportFilters: FC<IProps> = ({
  onFilterChange,
  filters,
  showActionsFilterModal,
  setShowActionsFilterModal
}) => {
  const { campaign } = useContext(ManageCampaignContext)

  const removeActionsFromFilter = (
    e: SyntheticEvent<EventTarget, Event>
  ): void => {
    e.stopPropagation()
    onActionsChanged([])
  }

  const getSelectedActionLabel = () => {
    if (filters.selectedActions.length > 1) {
      return t`${filters.selectedActions.length} actions`
    } else {
      const selectedAction = getFlatListOfActions(campaign).find(
        (action) =>
          action.id === filters.selectedActions[0].id &&
          action.actionType === filters.selectedActions[0].type
      ) as ICampaignActionForModal
      return selectedAction.label
    }
  }

  const onActionsChanged = (selectedActions) => {
    onFilterChange({ selectedActions })
  }

  return (
    <div className="CampaignReportsFilters">
      <div className="CampaignReportsFilters__wrapper">
        <Flex
          as="label"
          alignItems="center"
          className="CampaignReportsFilters__label"
        >
          <IconFilter mr="8px" />
          <Trans>Showing</Trans>:
        </Flex>

        {filters.selectedActions.length > 0 && (
          <ButtonDark
            className="CampaignReportsFilters__item"
            onClick={() => setShowActionsFilterModal(true)}
            leftIcon={<IconClose onClick={removeActionsFromFilter} />}
          >
            <span className="CampaignReportsFilters__item__label">
              {getSelectedActionLabel()}
            </span>
          </ButtonDark>
        )}

        <Dropdown
          tabIndex={-1}
          positionOfContent="left"
          _focus={{
            outline: 'none'
          }}
          content={
            <div className="AddFilterMenuList Dropdown">
              <div className="DropdownLabel">
                <Trans>Filter types</Trans>:
              </div>
              <ButtonClean
                className="DropdownLink"
                justifyContent="start"
                onClick={() => setShowActionsFilterModal(true)}
                disabled={filters.selectedActions.length > 0}
                leftIcon={<IconPeople />}
              >
                <Trans>Actions</Trans>
              </ButtonClean>
            </div>
          }
        >
          <ButtonClean
            size="sm"
            fontSize="md"
            m="4px"
            className="CampaignReportsFilters__add"
            leftIcon={<IconPlus2 />}
          >
            <Trans>Add filter</Trans>
          </ButtonClean>
        </Dropdown>
      </div>

      {showActionsFilterModal && (
        <FilterCampaignActionsModal
          onChange={onActionsChanged}
          selectedActions={filters.selectedActions}
          hideActionFilterModal={() => setShowActionsFilterModal(false)}
        />
      )}
    </div>
  )
}

export default CampaignLinkReportFilters
